<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.data"
        item-key="objectId"
        :loading="isLoading || isMainLoading"
        class="border-2 dataTable row-pointer data-table-customer"
        :items-per-page="20"
        :options.sync="tableOptions"
        :server-items-length="isKeyword ? -1 : projectCustomerCount"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50],
        }"
        @update:items-per-page="updateItemsPerPage"
        @update:page="updatePage"
        @update:sort-desc="updateSortBy"
        :no-data-text="$t('noinfo')"
        :no-results-text="$t('no_matching_records_found')">
        
        <template v-slot:header.companyName="{header}">
          <div class="text-nowrap-table text-center" style="min-width:190px">{{header.text}}</div>
        </template>
        <template v-slot:header.fullName="{header}">
          <div class="text-nowrap-table text-center" style="min-width:190px;">{{header.text}}</div>
        </template>

        <template v-slot:item.companyName="{ item }">
          <div class="text-truncate business-name text-start">
            {{ item.companyName }}
          </div>
        </template>
        <template v-slot:item.fullName="{ item }">
          <div class="text-truncate customer-name text-start">
            {{ item.fullName }}
          </div>
        </template>
        <template v-slot:item.contracts="{ item }">
          <div>
            <template v-for="contract in item.contracts">
              <template v-if="contract.contractId">
                <span class="block p-1 m-1 text-xs border rounded-md bg-gray-50">{{ contract.contractId }}
                  <span class="mx-1 text-sm" v-if="contract.stallType">({{
                    contract.stallType ? $t(`contact.stall_type.${contract.stallType}`) : '-'
                  }})</span></span>
              </template>
            </template>
          </div>
        </template>
        <template v-slot:item.emails="{ item }">
          <div style="max-width: 300px">
            <template v-for="email in item.emails">
              <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ email || "-" }}</span>
            </template>
          </div>
        </template>
        <template v-slot:item.tels="{ item }">
          <div style="max-width: 300px">
            <template v-if="item.interTels.filter(tel => tel && tel != '-').length">
              <template v-for="tel in item.interTels">
                <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ $helper.telToString([tel]) || "-" }}</span>
              </template>
            </template>
            <template v-else>
              <template v-for="tel in item.tels">
                <span class="block p-1 m-1 text-sm border rounded-md bg-gray-50">{{ $helper.telToString([tel]) || "-" }}</span>
              </template>
            </template>
          </div>
        </template>
        <template v-slot:item.view="{ item }">
          <a :href="`${item.objectId}/view`" target="_blank">
            <v-btn color="primary" text>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </a>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    projectId: String,
    isMainLoading: Boolean,
    isKeyword: Boolean,
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      tableOptions: {},
      itemsPerPage: 20,
      page: 0,
      order: {}
    };
  },
  computed: {
    ...mapState({
      projectCustomers: (state) => state.customer.projectCustomers,
      projectCustomerCount: (state) => state.customer.projectCustomerCount,
    }),
    dataTable() {
      return {
        headers: [
          { text: this.$t('bill.customer_market_id'), value: "customerId", sortable: false },
          { text: this.$t('customer.company_name_title'), value: "companyName",width: '1%', sortable: false ,class : 'custom-sort', align: 'center hd-resize text-truncate' },
          { text: this.$t('market.marchant_name'), value: "fullName",width: '1%',class : 'custom-sort', align: 'center hd-resize text-truncate'},
          { text: this.$t('account.email_address'), value: "emails", sortable: false },
          { text: this.$t('account.phone_number'), value: "tels", sortable: false },
          { text: "", value: "view", sortable: false },
        ],
        data: this.projectCustomers.map((i) => {
          i.customerId = i.customerId || "-";
          i.businessName = i.businessName || "-";
          i.emails = i.emails.length > 0 ? i.emails : ["-"];
          i.tels = i.tels.length > 0 ? i.tels : ["-"];
          i.interTels = i.interTels.length > 0 ? i.interTels : ["-"];
          i.fullName = i.firstName ? (i.title ? `${i.title} ` : "") + `${i.firstName} ${i.lastName}` : "-";
          return i;
        }),
      };
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("customer/getCustomersLengthByProject", {
          projectId: this.projectId,
        });
        await this.$store.dispatch("customer/getCustomersByProject", {
          projectId: this.projectId,
          limit: this.itemsPerPage,
          page: this.page,
          order: this.order
        });
        this.$emit("updateData", true);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async updateItemsPerPage() {
      if (!this.isKeyword) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
        this.itemsPerPage = itemsPerPage;
        this.page = page - 1;
        await this.fetchData(itemsPerPage, page - 1);
      }
    },
    async updatePage() {
      if (!this.isKeyword) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
        this.itemsPerPage = itemsPerPage;
        this.page = page - 1;
        await this.fetchData(itemsPerPage, page - 1);
      }
    },
    async updateSortBy() {
      if (!this.isKeyword) {
        const { sortBy, sortDesc } = this.tableOptions;
        this.order = {}
        if (sortDesc.length) {
          if (sortDesc[0]) {
            if (sortBy[0] == "fullName")
              this.order.descending = ["firstName", "lastName"]
            else
              this.order.descending = sortBy.map(d => d)
          } else {
            if (sortBy[0] == "fullName")
              this.order.ascending = ["firstName", "lastName"]
            else
              this.order.descending = sortBy.map(d => d)
          }
        }
        await this.fetchData()
      }
    }
  },
};
</script>

<style lang="scss" scoped>

.data-table-customer::v-deep td.hd-resize{
  max-width: 190px;
}

.data-table-customer::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 30px;
    top: 15px;
  }
}

// .text-start {
//   border-right: 1px solid #eee;
// }

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
  max-width: 250px;
}

.row-cursor tbody tr:hover {
  cursor: pointer;
}
.text-nowrap-table.business-name,
.text-nowrap-table.customer-name {
  width: 100%;
  text-align: center;
}
</style>
